window.addEventListener("load",(e=>{$(".currency-selector__redirect-url").each((function(){this.href+=window.location.pathname,this.data}))}));

class AnimateSticky extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.onScrollHandler = this.onScroll.bind(this);

        window.addEventListener('scroll', this.onScrollHandler, false);
        this.onScrollHandler();
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop >= this.getOffsetTop(this)) {
            requestAnimationFrame(this.reveal.bind(this));
        } else {
            requestAnimationFrame(this.reset.bind(this));
        }
    }

    reveal() {
        this.setAttribute('animate', '');
    }

    reset() {
        this.removeAttribute('animate');
    }

    getOffsetTop(element) {
        let offsetTop = 0;
        while(element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }
        return offsetTop;
    }
}
customElements.define('animate-sticky', AnimateSticky);

class ProductForm extends HTMLElement {
    constructor() {
        super();

        this.miniCart = document.querySelector('mini-cart');
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.form.addEventListener('change', this.onChangeHandler.bind(this));
    }

    onChangeHandler(evt) {
        const image = document.querySelector('.sticky-cart__content-image img');
        if (image) {
        image.srcset = `${evt.detail.featured_media.preview_image.src}&width=70 1x, ${evt.detail.featured_media.preview_image.src}&width=140 2x`;
        image.src = `${evt.detail.featured_media.preview_image.src}&width=70`;
        image.width = 70;
        image.height = Math.ceil(70 / evt.detail.featured_media.preview_image.aspect_ratio);
        }
    }

    onSubmitHandler(evt) {
        if (document.body.classList.contains('template-cart') || !shopSettings.cartDrawer) {
            return;
        }

        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) {
            return;
        }

        this.handleErrorMessage();

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.miniCart) {
            formData.append('sections', this.miniCart.getSectionsToRender().map((section) => section.id));
        }
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                }

                if (this.miniCart) {
                    this.miniCart.renderContents(response);
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
            });
    }

    handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (this.errorMessageWrapper) {
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
        else {
            if (errorMessage) {
                alert(errorMessage);
            }
        }
    }
}
customElements.define('product-form', ProductForm);

class QuantityInput extends HTMLElement {
    constructor() {
        super();

        this.init();
    }

    init() {
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define('quantity-input', QuantityInput);

class SelectWrapper extends HTMLElement {
    constructor() {
        super();
        console.log("selectwrapper constructor");
        theme.initWhenVisible({
            element: this,
            callback: this.init.bind(this),
            threshold: 200
        });

        this.select = this.querySelector('select');
        if (this.select) {
            console.log("select");
            this.select.addEventListener('change', this.handleSelectChange.bind(this));
        }
    }

    init() {
        console.log("init");
        const style = window.getComputedStyle(this.select);
        const value = this.select.options[this.select.selectedIndex].text;

        const text = document.createElement('span');
        text.style.fontFamily = style.fontFamily;
        text.style.fontSize = style.fontSize;
        text.style.fontWeight = style.fontWeight;
        text.style.visibility = 'hidden';
        text.style.position = 'absolute';
        text.innerHTML = value;

        document.body.appendChild(text);
        const width = text.clientWidth;

        this.style.setProperty('--width', `${width}px`);
        text.remove();
    }

    handleSelectChange() {
        console.log("pppp");
        this.init();
    }
}
customElements.define('select-wrapper', SelectWrapper);


// Init section function when it's visible, then disable observer
theme.initWhenVisible = function(options) {
    const threshold = options.threshold ? options.threshold : 0;
  
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, {rootMargin: `0px 0px ${threshold}px 0px`});
  
    observer.observe(options.element);
  };

class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      window.dateStrings = {
        d: `Datum`,
        day: `Tag`,
        days: `Tage`,
        hour: `Stunde`,
        hours: `Stunden`,
        minute: `Minute`,
        minutes: `Minuten`,
        second: `Sekunde`,
        seconds: `Sekunden`
      };
  
      this.parent = this.closest('.product-countdown');
      this.date = new Date(Date.parse(this.dataset.date)).getTime();
  
      if (isNaN(this.date)) {
        this.date = new Date(this.dataset.date.replace(/-/g, "/")).getTime();
        if (isNaN(this.date)) {
            this.date = new Date();
            this.date.setDate(this.date.getDate() + 1);
        }
        console.log("date: "+ this.date);
        if (isNaN(this.date)) {
          this.unload();
          return;
        }
      }

  //    this.init.bind(this)

  
      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 200
      });
    }
  
    init() {
      this.timer();
      this.dataset.interval = setInterval(this.timer.bind(this), 1000);
    }
  
    timer() {
        console.log("start timer");
      const now = new Date(),
        countTo = new Date(this.date),
        timeDifference = (countTo - now);
  
      if (timeDifference < 0) {
        this.unload();
        return;
      }
  
      const secondsInADay = 60 * 60 * 1000 * 24,
        secondsInAHour = 60 * 60 * 1000;
  
      const days = Math.floor(timeDifference / (secondsInADay) * 1);
      const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
      const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
      const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);
  
      if (this.dataset.compact == 'true') {
        const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}${dateStrings.d}</span></div>` : '';
        const otherHTML = `<div class="countdown__item"><span>${hours > 9 ? hours : '0' + hours}:${mins > 9 ? mins : '0' + mins}:${secs > 9 ? secs : '0' + secs}</span></div>`;
    
        this.innerHTML = dayHTML + otherHTML;
      }
      else {
        const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}</span> ${days == 1 ? dateStrings.day : dateStrings.days}</div>` : '';
        const hourHTML = `<div class="countdown__item"><span>${hours}</span> ${hours == 1 ? dateStrings.hour : dateStrings.hours}</div>`;
        const minHTML = `<div class="countdown__item"><span>${mins}</span> ${mins == 1 ? dateStrings.minute : dateStrings.minutes}</div>`;
        const secHTML = `<div class="countdown__item"><span>${secs}</span> ${secs == 1 ? dateStrings.second : dateStrings.seconds}</div>`;
  
        this.innerHTML = dayHTML + hourHTML + minHTML + secHTML;
      }
    }
  
    unload() {
      if (this.dataset.interval) {
        clearInterval(this.dataset.interval);
      }
  
      this.classList.add('hidden');
      if (this.parent) {
        this.parent.classList.add('hidden');
      }
    }
  }
  customElements.define('countdown-timer', CountdownTimer);
